// 支付方式
export let PAY = {
  'WX': 'wxpay_h5',
  'ZFB': 'alipay_h5',
  'WXGZ' : 'wxpay_gz'
}